module.exports = __webpack_public_path__ + "media/images/oak/slides/slide-2-full-849e2c01f567534afe86267ab82c21e1.jpg";